<template>
  <div>
    <div v-for="run in locations">
      <mapbox-marker
        :lng-lat="[run.lng, run.lat]"
        anchor="center"
        @click="onClick(run.id!)"
      >
        <template #icon v-if="run.avatarUrl">
          <img :src="run.avatarUrl" class="avatar" />
        </template>
      </mapbox-marker>
      <mapbox-popup
        :lng-lat="[run.lng, run.lat]"
        v-if="run.id == detailRunId"
        :offset="[0, 0]"
        anchor="bottom"
      >
        <div class="popup">
          <nuxt-link :to="`/runs/${run.id}`">Run</nuxt-link>
          <span>
            Last tracked:
            {{
              new Date(run.time + "Z").toLocaleString("en", {
                timeZone: "America/Los_Angeles",
              })
            }}
          </span>
          <ProCTA
            ><template #text
              >Go Pro to see historical tracking</template
            ></ProCTA
          >
        </div>
      </mapbox-popup>
      <mapbox-marker
        v-for="run in locations"
        :lng-lat="[run.lng, run.lat]"
        :offset="[0, 10]"
        anchor="top-left"
        @click="run.id && onClick(run.id)"
      >
        <template #icon>
          {{ run.name }}
        </template>
      </mapbox-marker>
    </div>

    <RunEvents
      v-if="subscribed && detailRunId"
      :key="detailRunId"
      :run-id="detailRunId"
    />
  </div>
</template>
<script lang="ts" setup>
const props = defineProps({
  courseId: {
    type: String,
    required: true,
  },
});

function onClick(runId: string) {
  setTimeout(() => (detailRunId.value = runId), 10);
}

const detailRunId = ref();
const subscribed = isSubscriber();

const query = useSupabaseQuery({
  queryKey: () => ["live-locations", props.courseId],
  queryFn: (supabase) =>
    supabase
      .from("runs")
      .select("*,latest_locations(user_id,lat,lng,time),users(*)")
      .eq("course_id", props.courseId)
      .limit(30),
  refetchInterval: 30000,
});

const locations = computed(() =>
  query.data.value?.map(
    (run) =>
      ({
        id: run.id,
        avatarUrl: run.users.at(0)?.avatar_url,
        name:
          run.team_name || run.team_number
            ? `${run.team_number} - ${run.team_name}`
            : run.users.map((u) => u.name || u.username).join(", "),
        ...(run.latest_locations.at(0) || run.latest_locations),
      } || [])
  )
);
</script>
<style scoped>
.avatar {
  width: 20px;
  height: 20px;
  border-radius: 100%;
  opacity: 0.89;
  border: 1px solid black;
  box-shadow: 1px 1px 3px white;
}
.popup {
  display: flex;
  flex-direction: column;
}
</style>
